import React, { useContext, useState, useCallback } from 'react';

interface ModalStack {
  readonly stack: React.ReactChild[];
  push: (child: React.ReactChild) => void;
  pop: () => void;
}

const ModalStackContext = React.createContext<ModalStack>({
  stack: [],
  push: () => {},
  pop: () => {},
});

export const ModalProvider: React.SFC = ({ children }) => {
  const [stack, setStack] = useState<React.ReactChild[]>([]);

  const push = useCallback((component: React.ReactChild) => {
    setStack((stack) => [...stack, component]);
  }, []);

  const pop = useCallback(() => {
    setStack((stack) => {
      const newStack = [...stack];
      newStack.pop();
      return newStack;
    });
  }, []);

  return (
    <ModalStackContext.Provider value={{ stack, push, pop }}>
      {children}
      {stack.length > 0 && stack[stack.length - 1]}
    </ModalStackContext.Provider>
  );
};

const useModalStack = () => {
  const context = useContext(ModalStackContext);
  return { push: context.push, pop: context.pop, stack: [...context.stack] };
};

export default useModalStack;
